import React from "react";
import currency from "currency.js";
import { commonConstants } from "../_redux/_constants";

const NumberFormatter = (
  number,
  currencyCode = commonConstants.RUPEES_CURRENCY_CODE,
) => {
  if (number == null || Number.isNaN(Number(number))) {
    return "";
  }

  const absValue = Math.abs(number);
  const formatted = currency(absValue, {
    symbol: currencyCode + " ",
    separator: ",",
  }).format();
  return number < 0
    ? `${currencyCode} -${currency(absValue, {
        symbol: "",
        separator: ",",
      }).format()}`
    : formatted;
};

export const toTwoDecimalAmount = (value) => {
  const numericText = String(value ?? "").replace(/[^\d.]/g, "");
  if (!numericText || Number(numericText) === 0 || Number.isNaN(Number(numericText))) {
    return "";
  }
  return Number(numericText).toFixed(2);
};

export const amountHasTwoDecimals = (value) =>
  /^\d+\.\d{2}$/.test(String(value ?? ""));

export const formatExactDecimal = (
  value,
  currencyCode = commonConstants.RUPEES_CURRENCY_CODE,
) => {
  const text = String(value ?? "").trim();
  const coded = text.match(/^([A-Za-z]{3})\s+(.+)$/);
  const code = coded ? coded[1] : currencyCode;
  const amountText = coded ? coded[2].trim() : text;
  const negative = amountText.startsWith("-");
  const unsigned = (negative ? amountText.slice(1) : amountText).replace(
    /,/g,
    "",
  );
  const dotIndex = unsigned.indexOf(".");
  const whole = dotIndex === -1 ? unsigned : unsigned.slice(0, dotIndex);
  const fractionDigits = dotIndex === -1 ? "" : unsigned.slice(dotIndex + 1);
  const paddedFraction = fractionDigits.padEnd(2, "0");
  const grouped = (whole.replace(/^0+(?=\d)/, "") || "0").replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ",",
  );
  const body = `${grouped}.${paddedFraction}`;

  return negative ? `${code} -${body}` : `${code} ${body}`;
};

export default NumberFormatter;
